import BaseApi from "./BaseApi";

export default class Accesses extends BaseApi {
    construct() {}

    static async list(params = {}) {
        return await Accesses.getAxiosInstance().get(Accesses.getApiUrl(), {
            params
        });
    }

    static async search(params = {}) {
        return await Accesses.getAxiosInstance().get(Accesses.getApiUrl() + "/search", {
            params
        });
    }

    static async create(params) {
        return await Accesses.getAxiosInstance().post(Accesses.getApiUrl(), params);
    }

    static async update(params, id) {
        return await Accesses.getAxiosInstance().put(Accesses.getApiUrl() + "/" + id, params);
    }

    static async delete(id) {
        return await Accesses.getAxiosInstance().delete(Accesses.getApiUrl() + "/" + id);
    }

    static async get(id) {
        return await Accesses.getAxiosInstance().get(Accesses.getApiUrl() + "/" + id);
    }

    static async getAll() {
        return await Accesses.getAxiosInstance().get(Accesses.getApiUrl() + "/all");
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "accesses";
    }
}